'use es6';

import createBatchedReferenceResolver from 'reference-resolvers/lib/createBatchedReferenceResolver';
import { WORKFLOW_FOLDERS } from 'reference-resolvers/constants/CacheKeys';
import { getWorkflowFoldersByIds, getWorkflowFoldersSearchPage, createGetWorkflowFoldersByIds, createGetWorkflowFoldersSearchPage } from 'reference-resolvers/api/WorkflowFoldersAPI';
export const createWorkflowFolderReferenceResolver = options => createBatchedReferenceResolver(Object.assign({
  cacheKey: WORKFLOW_FOLDERS,
  createFetchByIds: createGetWorkflowFoldersByIds,
  createFetchSearchPage: createGetWorkflowFoldersSearchPage,
  fetchByIds: getWorkflowFoldersByIds,
  fetchSearchPage: getWorkflowFoldersSearchPage
}, options));
export default createWorkflowFolderReferenceResolver();